import axios from "axios";
import Moment from "moment";
import {
  DELETE_KEY,
  GET_LOCATION_LIST,
  MAKE_LOCATION,
  DELETE_LOCATION,
  UPDATE_CONTRACT,
  DELETE_HISTORY,
  UPDATE_DETAIL,
  SET_DETAIL
} from "../constant";

import { FormMenu } from "../components/FormMenu";
const { decorate, observable, action, toJS } = require("mobx");

class Location {
  locationList = [];
  series = [];
  history = [];
  location = [];
  blocking = false;

  async getLocationList() {
    let response = await axios.get(GET_LOCATION_LIST);
    let data = await response.data;
    this.locationList = data;
    return data;
    // await this.makeSeries();
  }
  async makeLocation(locname, loc) {
    try {
      let response = await axios.post(MAKE_LOCATION, {
        locname: locname,
        loc: loc
      });
      await this.getLocationList();
    } catch (error) {
      throw error;
    }
  }

  async deleteLocation(locname) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      let response = await axios.delete(
        DELETE_LOCATION + locname,
        {
          data: { deleteKey: DELETE_KEY }
        },
        config
      );
      await this.getLocationList();
    } catch (error) {
      throw error;
    }
  }

  async updateContract(location) {
    try {
      let response = await axios.put(UPDATE_CONTRACT, { location: location });
      await this.getLocationList();
      return response;
    } catch (e) {
      throw e;
    }
  }

  async updateDetail(location) {
    try {
      let response = await axios.put(UPDATE_DETAIL, { location: location });
      await this.getLocationList();
      return response;
    } catch (e) {
      throw e;
    }
  }

  async setDetail(locname, detail, user) {
    try {
      this.blocking = true;
      let response = await axios.put(SET_DETAIL, {
        detail: detail,
        locname: locname,
        user: user
      });
      await this.getLocationList();
      this.blocking = false;
      return response;
    } catch (e) {
      this.blocking = false;
      throw e;
    }
  }

  async makeSeries() {
    var locationList = this.locationList;
    var sum = 0;
    var sw = 0;
    var hw = 0;
    var db = 0;
    var argos = 0;
    var smartMobile = 0;
    var seat = 0;
    var loss = 0;
    var reading = 0;
    var etc = 0;

    locationList.forEach(location => {
      var contract = location.contract;
      if (contract != "undefined" && contract != null) {
        var keys = Object.keys(contract);
        keys.forEach(key => {
          var val = contract[key];
          if (typeof val == "number") {
            sum += val;
            switch (key) {
              case "sw":
                sw += val;
                break;
              case "hw":
                hw += val;
                break;
              case "db":
                db += val;
                break;
              case "argos":
                argos += val;
                break;
              case "smartMobile":
                smartMobile += val;
                break;
              case "seatManagement":
                seat += val;
                break;
              case "lossPrevention":
                loss += val;
                break;
              case "readingCertification":
                reading += val;
                break;
              case "etc":
                etc += val;
                break;
            }
          }
        });
      }
    });

    const series = [
      {
        name: "합계",
        data: [sw, hw, db, argos, smartMobile, seat, loss, reading, etc, sum]
      }
    ];

    this.series = series;
  }

  async getHistory(locname) {
    await this.getLocationList();
    var locationList = toJS(this.locationList);
    var location = locationList.find(item => {
      return item.locname == locname;
    });
    if (!location) {
      this.history = [
        {
          title: "Error",
          subtitle: "존재하지 않는 기관입니다",
          date: Moment().format("YYYY-MM-DD")
        }
      ];
      return;
    }
    var history = location.history;
    history.sort((a, b) => {
      var d1 = new Date(a.date).getTime();
      var d2 = new Date(b.date).getTime();
      var val = d2 - d1;
      if (val == 0 && a.title == "기관생성") {
        return 1;
      } else {
        return -1;
      }
      return val;
    });
    this.history = history;
  }

  async deleteHistory(locname, item) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      let response = await axios.delete(
        DELETE_HISTORY + locname,
        {
          data: { deleteKey: DELETE_KEY, item: item }
        },
        config
      );
      await this.getHistory(locname);
    } catch (error) {
      throw error;
    }
  }

  getLocation(locname) {
    if (this.locationList.length == 0) {
    }
    if (this.locationList.length > 0) {
      const loc = this.locationList.find(item => item.locname == locname);
      return loc;
    } else {
      (async () => {
        await this.getLocationList();
        const loc = this.locationList.find(item => item.locname == locname);
        return loc;
      })();
    }
  }
  getDetail(locname) {
    const loc = this.getLocation(locname);
    if (loc) {
      const detail = loc.detail;
      return detail;
    } else {
      return [];
    }

    // let menus = new Array();
    // if (detail != "undefined" && detail != null) {
    //   var keys = Object.keys(detail);

    //   keys.forEach((key) => {
    //     var val = detail[key];
    //     var menuItem = {
    //       title: key,
    //       val: val,
    //     };
    //     menus.push(menuItem);
    //   });
    // }

    // FormMenu.map((item) => {
    //   var target = menus.find((menu) => menu.title == item.title);
    //   if (!target) {
    //     var menuItem = {
    //       title: item.title,
    //       val: "",
    //     };
    //     menus.push(menuItem);
    //   }
    // });

    // return menus;
  }
}

decorate(Location, {
  locationList: observable,
  series: observable,
  history: observable,
  blocking: observable,
  getLocationList: action,
  deleteLocation: action,
  updateContract: action,
  updateDetail: action,
  getHistory: action,
  deleteHistory: action,
  getLocation: action,
  getDetail: action
});

const location = new Location();
export default location;
